// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3ndGF","inputWrap":"styles_inputWrap__3D7jN","input":"styles_input__3KDUu"};